const config = {
  localApiBaseURL: "http://localhost:5000/api",
  prodApiBaseURL: "https://api.closesttothepinchallenge.com/api"
}
export default config;
